import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo, useEffect } from "react";
import { useFeedbackPopover } from "../../app/navigation/top-navigation/feedback-popover-context";
import { OnboardingProps } from "../common";

export const FeedbackAnnouncementOnboarding = memo(
  function FeedbackAnnouncementOnboarding({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    const { open, isOpen } = useFeedbackPopover();

    useEffect(() => {
      if (isOpen) {
        handleComplete();
      }
    }, [isOpen, handleComplete]);

    return (
      <RedoFeatureNotificationCard
        actionText="Try it"
        description="Tell us what's working and what isn't, right from the top corner."
        onAction={open}
        onDismiss={handleDismiss}
        title="Share feedback in one click"
      />
    );
  },
);
